import React from "react";
import { StepCircle, StepLine, StepperWrapper } from "./style";

type Props = {
  currentStep: number;
  numberOfSteps: number;
  stepNames: string[];
};

const Stepper = ({ currentStep, numberOfSteps, stepNames }: Props) => {
  const isStepActive = (index: number) => currentStep >= index + 1;

  return (
    <StepperWrapper>
      {Array.from({ length: numberOfSteps }).map((_, index) => (
        <React.Fragment key={index}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <StepCircle isActive={isStepActive(index)}>{index + 1}</StepCircle>
            <span>{stepNames[index]}</span>
          </div>
          {index < numberOfSteps - 1 && (
            <StepLine isActive={isStepActive(index)} />
          )}
        </React.Fragment>
      ))}
    </StepperWrapper>
  );
};

export default Stepper;
